module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/modules/_library.js
// module id = 38
// module chunks = 0